module.exports = __webpack_public_path__ + "img/f2f.075ade43.svg";